/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { FaGaugeHigh, FaMagnifyingGlassChart, FaPeopleGroup } from 'react-icons/fa6'
import LoadingContainer from '../../../../components/LoadingContainer'
import { SelectCmp } from '../../../../components/SelectCmp'
import { appApi } from '../../../../services/appApi'
import { Body } from '../../../Layouts/Body'
import { itemGestao } from '../dashboard'
import { BoxQtd } from '../dashboard/components/BoxQtd'
import { ModalTabelaAderencia } from '../dashboard/components/ModalTabelaAderencia'
import { GraficoBP } from './components/GraficoBP'
import { GraficoCalibracao } from './components/GraficoCalibracao'
import { GraficoCamposAlterados } from './components/GraficoCamposAlterados'
import { GraficoPerfilInterno } from './components/GraficoPerfilInterno'
import { GraficoPontos } from './components/GraficoPontos'
import { GraficoResultado } from './components/GraficoResultado'
import { ModalAnalise } from './components/ModalAnalise'
import { PanoramaChart } from './components/PanoramaChart'

export interface IAderenciaChartProps{
  aderentes: number
  aderentesRessalva: number
  naoAderentes: number
  total: number
}
export interface IPanorama{
  id?: string
  aderentes: IAderenciaChartProps
  naoAderentes: IAderenciaChartProps
  aderentesRessalva: IAderenciaChartProps
  resultadoEntregue: IAderenciaChartProps
  resultadoComputado: IAderenciaChartProps

}
export interface Ipesquisas{

  bp: number
  bpResposta: number
  totalLiberados: number
  contratados: number

}

export interface IDadosAlterados{

  quantidade: number
  percentual: number
  campo: string

}

export interface IDashModel{
  panorama: IPanorama
  total: number
  totalAnalisados: number
  totalAderenciaCorreta: number
  totalAderenciaCalibrada: number
  pesquisas: Ipesquisas
  camposAlterados: IDadosAlterados[]
  pontosTotaisPercebidos: number
  pontosAtencaoPercebidos: number
  pontosFortesPercebidos: number
  pesquisasPontosPercebidos: number
  tipoCandidatosInternos: number
  tipoCandidatosExternos: number
  relatoriosAlterados: number
  relatoriosInalterados: number
}
export interface IAssessmentCamposModel{
  assessments: ICamposModel[]
  campo: string
}
export interface ICamposModel{
  id: string
  nome: string
  data: string
  campoOriginal: string[]
  campoAlterado: string[]

}

export const DashboardSIIA: React.FC = () => {
  const [IsLoadingBody, setIsLoadingBody] = useState(false)

  const [DashModel, setDashModel] = useState<IDashModel>()
  const [AssessmentCamposModel, setAssessmentCamposModel] = useState<IAssessmentCamposModel>()
  const [filtroData, setFiltroData] = useState(0)
  const [modalAnalise, setModalAnaliseOpen] = useState(false)
  const [modalAderencia, setModalAderencia] = useState(false)
  const [AssessmentAderencia, setAssessmentAderencia] = useState<itemGestao[]>([])
  const [posicaoChart, setPosicaoChart] = useState({ index: 0, serie: 0 })

  // useEffect(() => {
  //   setIsLoadingBody(false)
  //   onGetDash()
  // }, [])

  useEffect(() => {
    onGetDash()
  }, [filtroData])

  // useEffect(() => {
  //   if (modalCandidatosOpen) {
  //     alert('vai na api!')
  //   }

  //   getCandidatos()
  // }, [modalCandidatosOpen])

  // function getCandidatos(): void {
  //   setIsLoadingBody(true)
  //   // appApi.get('api/SIDashboardIA')
  //   //   .then((res) => setDashModel(res.data))
  //   //   .catch((err) => console.log(err))
  //   //   .finally(() => {
  //   //     setTimeout(() => {
  //   //       setIsLoadingBody(false)
  //   //     }, 400)
  //   //   })
  //   setTimeout(() => {
  //     setIsLoadingBody(false)
  //   }, 400)
  // }
  function onGetCampos(campo: string): void {
    setIsLoadingBody(true)
    appApi.get(`api/SIDashboardIA/FiltradoCampos/?filtro=${filtroData}&campo=${campo}`)
      .then((res) => setAssessmentCamposModel(res.data))
      .catch((err) => console.log(err))
      .finally(() => {
        setModalAnaliseOpen(true)
        setTimeout(() => {
          setIsLoadingBody(false)
        }, 100)
      })
  }
  function getCandidatosFiltrados(index: number, serie: number): void {
    setIsLoadingBody(true)
    appApi.get(`api/SIDashboardIA/FiltroCandidatos/?filtro=${filtroData}&index=${index}&serie=${serie}`)
      .then((res) => setAssessmentAderencia(res.data))
      .catch((err) => console.log(err))
      .finally(() => {
        setPosicaoChart({ index, serie })
        setModalAderencia(true)
        setTimeout(() => {
          setIsLoadingBody(false)
        }, 100)
      })
  }

  function onGetDash(): void {
    setIsLoadingBody(true)
    appApi.get(`api/SIDashboardIA?filtro=${filtroData}`)
      .then((res) => setDashModel(res.data))
      .catch((err) => console.log(err))
      .finally(() => {
        // setTimeout(() => {
        setIsLoadingBody(false)
        // }, 400)
      })
  }
  const baixarRelatorio = async (model: itemGestao, linkUrl: string, posNomeArquivo: string) => {
    const response = await fetch(linkUrl)
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${model.nome.replaceAll(' ', '_')}_${posNomeArquivo}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  function onChangeStatus(id: string, status: string): void {
    setIsLoadingBody(true)
    appApi.put(`api/SI/${id}/trocarStatus?statusNovo=${status}`)
      .then((res) => getCandidatosFiltrados(posicaoChart.index, posicaoChart.serie))
      .catch((err) => { console.log(err); setIsLoadingBody(false) })
  }

  return (<Body isLoading={IsLoadingBody}>
     {modalAnalise && <ModalAnalise
        IsLoading={'false'}
        isOpen={modalAnalise}
        assessments={AssessmentCamposModel ?? { assessments: [], campo: '' }}
        onRequestClose={() => {
          setModalAnaliseOpen(false)
          //  setCandidatos([])
        }}
        filtro={filtroData}
        titulo={'Analise Campos alterados'}
      />}
      {modalAderencia && <ModalTabelaAderencia
      candidatos={AssessmentAderencia}
      isOpen={modalAderencia}
      tipoAcesso={1}
      IsLoading={''}
      baixarRelatorio={baixarRelatorio}
      onChangeStatus={onChangeStatus}
      onRequestClose={() => {
        setModalAderencia(false)
        setAssessmentAderencia([])
      }}
      titulo={`Candidatos :${AssessmentAderencia.length}`}
      />}
  {DashModel &&
  <LoadingContainer linhas={30} loading={IsLoadingBody}>

<Flex justifyContent={'center'} gap='2rem'>
      <Flex maxWidth={'1080px'} direction={'column'} alignItems={'center'} gap='2rem'>

          <Flex width={'100%'} justifyContent={'space-between'} alignItems='center' >
            <Text fontWeight='bold' fontSize={'2xl'}>Dashboard Feedback e Calibração IA</Text>

      <SelectCmp
        value={filtroData.toString()}
        OnChange={(e) => setFiltroData(Number(e))}
      >
        <option value={0}>Período Completo</option>
        <option value={30}>Últimos 30 dias</option>
        <option value={60}>Últimos 60 dias</option>
      </SelectCmp>

            </Flex>
          <Flex width={'100%'} justifyContent={'space-around'} gap='1rem' >
            <BoxQtd
              titulo='Assessments'
              icon={<FaPeopleGroup size={30}/>}
              quantidade={DashModel.total}
            />
            <BoxQtd
              titulo='Relatórios analisados'
              icon={<FaMagnifyingGlassChart size={30}/>}
              quantidade={DashModel.totalAnalisados}
            />
            <BoxQtd
              titulo='Acurácia aderência'
              icon={<FaGaugeHigh size={30}/>}
              quantidade={ `${(100 * (DashModel.totalAderenciaCorreta / DashModel.totalAnalisados)).toFixed(2)} %`}
            />
            {/* <BoxQtd
              titulo='Calibração aderência'
              icon={<FaGauge size={30}/>}
              quantidade={ `${((100 * (DashModel.totalAderenciaCalibrada / DashModel.totalAnalisados)).toFixed(2))} %`}
            /> */}

          </Flex>
    <Flex width={'100%'} justifyContent={'start'} fontWeight='bold' fontSize={'2xl'}>Aderência dos assessments</Flex>
<Flex width={'100%'} justifyContent={'space-between'}>
  <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
    <PanoramaChart
    id='panorama-chart'
    key='panorama-chart'
    aderentes={DashModel.panorama.aderentes}
    aderentesRessalva={DashModel.panorama.aderentesRessalva}
    naoAderentes={DashModel.panorama.naoAderentes}
    resultadoComputado={DashModel.panorama.resultadoComputado}
    resultadoEntregue={DashModel.panorama.resultadoEntregue}
    onChoiceAderencia={(a, b) => getCandidatosFiltrados(a, b)}
    />
   </Box>

  <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
    <GraficoResultado
    id='resultadoGrafico'
    key='resultadoGrafico'
    resultadoComputado={DashModel.panorama.resultadoComputado}
    resultadoEntregue={DashModel.panorama.resultadoEntregue}
    onChoiceAderencia={(a, b) => getCandidatosFiltrados(a + 3, b)}

    />
   </Box>
   </Flex>
<Flex width={'100%'} justifyContent={'space-between'}>

   <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
    <GraficoCalibracao
    id={'grafico-calibracao'}
    key={'grafico-calibracao'}
    aderenciaOriginal={DashModel.totalAderenciaCorreta}
    analisados = {DashModel.totalAnalisados}
    calibradosAderencia={DashModel.totalAderenciaCalibrada}
    total = {DashModel.total}
    />
   </Box>
   <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
    <GraficoPerfilInterno
    id={'grafico-perfil-interno'}
    key={'grafico-perfil-interno'}
    total = {DashModel.totalAnalisados}
    externos = {DashModel.tipoCandidatosExternos}
    internos = {DashModel.tipoCandidatosInternos}

    />
   </Box>

</Flex>
     <Flex width={'100%'} justifyContent={'start'} fontWeight='bold' fontSize={'2xl'}>Ajustes dos assements</Flex>

<Flex width={'100%'} justifyContent={'space-around'} gap='1rem' >
            <BoxQtd
              titulo='Assessments ajustados'
              icon={<FaPeopleGroup size={30}/>}
              quantidade={ `${(100 * (DashModel.relatoriosAlterados / DashModel.totalAnalisados)).toFixed(2)} %`}
              // quantidade={DashModel.relatoriosAlterados}
            />
            <BoxQtd
              titulo='Relatórios inalterados'
              icon={<FaMagnifyingGlassChart size={30}/>}
              quantidade={ `${(100 * (DashModel.relatoriosInalterados / DashModel.totalAnalisados)).toFixed(2)} %`}
            />
            <BoxQtd
              titulo='Aderência alterada'
              icon={<FaGaugeHigh size={30}/>}
              quantidade={ `${(100 * (DashModel.totalAderenciaCorreta / DashModel.totalAnalisados)).toFixed(2)} %`}
            />
            {/* <BoxQtd
              titulo='Calibração aderência'
              icon={<FaGauge size={30}/>}
              quantidade={ `${((100 * (DashModel.totalAderenciaCalibrada / DashModel.totalAnalisados)).toFixed(2))} %`}
            /> */}

          </Flex>

<Flex width={'100%'} justifyContent={'space-around'}>
  <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
   <Flex direction={'column'}>
   {/* <Flex justifyContent={'end'} mb='1rem' >
    <Text>Visualização</Text>
    <select onChange={(e) => setVisualizacao(Number(e.target.value))}>
    <option value="100">100%</option>
    <option value="75">75%</option>
    <option value="50">50%</option>
    </select>
    </Flex > */}

    <GraficoCamposAlterados
    id={'Grafico-CamposAlterados'} listaCamposAlterados={DashModel.camposAlterados}
    escala={100}
    onChoiceCampo={(a, b) => onGetCampos(b)}
    />
</Flex>
  </Box>
</Flex>
    <Flex width={'100%'} justifyContent={'start'} fontWeight='bold' fontSize={'2xl'}>Percepção dos BP e gestores</Flex>
<Flex width={'100%'} justifyContent={'space-between'}>
  <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>

    <GraficoBP
    id='pesquisaBP-chart'
    key='pesquisaBP-chart'
    respostasBp={DashModel.pesquisas.bpResposta}
    totalLiberados={DashModel.pesquisas.totalLiberados}
    pesquisasDisparadas={DashModel.pesquisas.bp}
    contratados = {DashModel.pesquisas.contratados}

    />

   </Box>

  <Box border={'1px solid var(--c6)'} bgColor={'white'} rounded={'md'} p='2rem'>
  <GraficoPontos
   id={'graficoPontos'}
   pontosTotaisPercebidos={DashModel.pontosTotaisPercebidos}
   pontosAtencaoPercebidos={DashModel.pontosAtencaoPercebidos}
    pontosFortesPercebidos={DashModel.pontosFortesPercebidos}
     pesquisasPontosPercebidos={DashModel.pesquisasPontosPercebidos}/>
   </Box>
</Flex>

</Flex>
</Flex>
  </LoadingContainer>
  }
</Body>)
}
